"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getInitialContext = () => ({
    appointment: undefined,
    appointmentId: undefined,
    cancelEmail: undefined,
    cancelEmailConsent: false,
    cancelReasonText: '',
    locationId: undefined,
    locations: [],
    providerId: undefined,
    provider: undefined,
    capabilities: undefined,
    appointmentQuery: undefined,
    services: {
        cancelAppointment: () => {
            throw new Error('callback not defined');
        },
        getAppointment: () => {
            throw new Error('callback not defined');
        },
        getProvider: () => {
            throw new Error('callback not defined');
        },
        getCancellationReasons: () => {
            throw new Error('callback not defined');
        }
    },
    track: (event) => {
        // Placeholder implementation for tracking events
        // eslint-disable-next-line no-console
        console.log(`Tracking event: ${event}`);
    },
    searchProvidersLink: '',
    cancellationReasons: [],
    selectedCancellationReason: undefined
});
exports.default = getInitialContext;
//# sourceMappingURL=getInitialContext.js.map